function showPopupIfNeeded(data) {
    const current_url = window.location.href;
    if (typeof data.expected_site === 'undefined' || data.expected_site === null) {
        return;
    }

    const expectedSite = data.expected_site;
    const otherSite = data.other_site;

    if (current_url.startsWith(expectedSite.domain)) {
        return;
    }

    const modalScreen = document.querySelector('.js-language-modal');
    const documentBody = document.body;

    const goToButton = document.getElementById('js-go-to-btn');
    const goToButtonText = document.getElementById('js-go-to-btn-text');

    const stayButton = document.getElementById('js-stay-on-btn');
    const stayButtonText = document.getElementById('js-stay-on-btn-text');

    goToButton.setAttribute('href', expectedSite.move_to_site_url)
    goToButton.setAttribute('onclick', "dataLayer.push({'event': 'popup_site_switcher_click', 'category': 'popup', 'label': '" + expectedSite.gtm_event_label_move_to + "'})")
    goToButtonText.innerHTML = "Ga naar " + expectedSite.domain.replace('https://', '')

    stayButton.setAttribute('onclick', "dataLayer.push({'event': 'popup_site_switcher_click', 'category': 'popup', 'label': '" + otherSite.gtm_event_label_stay_on + "'})")
    stayButton.addEventListener('click', function(event) {
        event.preventDefault();
        modalScreen.classList.remove('open');
        documentBody.classList.remove('no-scroll');
    })
    stayButtonText.innerHTML = "Blijf op " + otherSite.domain.replace('https://', '')

    modalScreen.classList.add('open')
    documentBody.classList.add('no-scroll')
}


function checkRedirect() {
    const current_url = window.location.href;
    const domain = current_url.split('/').slice(0,3).join('/');

    const previousURL = document.referrer;
    if (!previousURL || !previousURL.startsWith(domain)) {
        if (window["fetch"]) {
            fetch('/wp-json/redirect/v1/get_user_info')
                .then((data) => data.json())
                .then((json) => showPopupIfNeeded(json))
        }
    }
}

checkRedirect();
